import { c as _c } from "react/compiler-runtime";
import { cn } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';
interface ChatInputToolbarProps {
  children: ReactNode;
  className?: string;
}

/**
 * Toolbar component for chat input actions.
 * Accepts children for flexible composition of toolbar buttons and actions.
 *
 * @example
 * ```tsx
 * <ChatInputToolbar>
 *   <div className="flex items-center gap-2">
 *     <ChatAttachments />
 *   </div>
 *   <div className="flex items-center gap-2">
 *     <SendButton />
 *   </div>
 * </ChatInputToolbar>
 * ```
 */
export function ChatInputToolbar(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-full flex-1 items-center p-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}